module.exports = __webpack_public_path__ + "static/media/image-7.da7f8135.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/depto-nuevo/image-7.jpg
// module id = 260
// module chunks = 0